
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"26","viewBox":"0 0 20 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 10C20 15.5228 10 25.5 10 25.5C10 25.5 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z","fill":"#6BBD6C"}}),_c('path',{attrs:{"d":"M10.368 6.21554L11.6906 8.74103L14.6482 9.14601C14.9848 9.19208 15.1192 9.58184 14.8756 9.80555L12.7355 11.7713L13.2407 14.5471C13.2982 14.863 12.9464 15.1039 12.6453 14.9547L9.99998 13.6442L7.35464 14.9547C7.05363 15.1038 6.70179 14.863 6.75929 14.5471L7.26451 11.7713L5.12436 9.80553C4.88082 9.58182 5.01522 9.1921 5.35178 9.14599L8.30937 8.74101L9.63204 6.21554C9.78256 5.92815 10.2174 5.92815 10.368 6.21554Z","fill":"white"}})])
          )
        }
      }
    